import { AccountTree, BarChart, Book, Engineering, Grading, Home, Place } from "@mui/icons-material"

const adminOpdRoutes = [
    {
        type: "route",
        name: "Dashboard",
        key: ['/a-pd'],
        route: "/a-pd",
        icon: <Home size="12px" color="warning" />,
        noCollapse: true,
    },
    {
        type: "route",
        name: "Perencanaan",
        key: ['/a-pd/perencanaan', '/a-pd/perencanaan/rincian-belanja'],
        route: "/a-pd/perencanaan",
        icon: <Grading size="12px" color="success" />,
        noCollapse: true,
    },
    // {
    //     type: "route",
    //     name: "Pendapatan",
    //     key: ['/a-pd/pendapatan'],
    //     route: "/a-pd/pendapatan",
    //     icon: <Grading size="12px" color="success" />,
    //     noCollapse: true,
    // },
    {
        type: "route",
        name: "Struktur Anggaran",
        key: ['/a-pd/struktur-anggaran'],
        route: "/a-pd/struktur-anggaran",
        icon: <AccountTree size="12px" color="primary" />,
        noCollapse: true,
    },
    {
        type: "route",
        name: "Anggaran Kas",
        key: ['/a-pd/anggaran-kas'],
        route: "/a-pd/anggaran-kas",
        icon: <BarChart size="12px" color="secondary" />,
        noCollapse: true,
    },
    // {
    //     type: "collapse",
    //     name: "Laporan Realisasi",
    //     key: ['laporan-belanja', 'laporan-belanja/rincian-belanja', 'laporan-belanja/komponen', 'laporan-pendapatan', 'laporan-pendapatan/komponen'],
    //     icon: <Grading size="12px" color="error" />,
    //     collapse: [
    //         {
    //             name: "Pendapatan",
    //             key: ['/a-pd/laporan-pendapatan', '/a-pd/laporan-pendapatan/komponen'],
    //             route: "/a-pd/laporan-pendapatan",
    //         },
    //         {
    //             name: "Belanja",
    //             key: ['/a-pd/laporan-belanja', '/a-pd/laporan-belanja/rincian-belanja', '/a-pd/laporan-belanja/komponen'],
    //             route: "/a-pd/laporan-belanja",
    //         },
    //     ],
    // },
    {
        type: "route",
        name: "Laporan",
        key: ['/a-pd/laporan-belanja', '/a-pd/laporan-belanja/rincian-belanja', '/a-pd/laporan-belanja/komponen'],
        route: "/a-pd/laporan-belanja",
        icon: <Grading size="12px" color="success" />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "Paket Pekerjaan",
        key: ['belanja','belanja-modal', 'proyek-strategis', 'paket-dak', 'belanja/komponen', 'belanja-modal/komponen', 'proyek-strategis/komponen', 'paket-dak/komponen'],
        icon: <Engineering size="12px" color="error" />,
        collapse: [
            {
                name: "Komponen Belanja",
                key: ['/a-pd/belanja', '/a-pd/belanja/komponen'],
                route: "/a-pd/belanja",
            },
            {
                name: "Belanja Modal",
                key: ['/a-pd/belanja-modal', '/a-pd/belanja-modal/komponen'],
                route: "/a-pd/belanja-modal",
            },
            {
                name: "Proyek Strategis",
                key: ['/a-pd/proyek-strategis', '/a-pd/proyek-strategis/komponen'],
                route: "/a-pd/proyek-strategis",
            },
            {
                name: "Proyek DAK",
                key: ['/a-pd/paket-dak', '/a-pd/paket-dak/komponen'],
                route: "/a-pd/paket-dak",
            },
        ],
    },
    // {
    //     type: "route",
    //     name: "Paket Pekerjaan",
    //     key: ['/a-pd/paket-pekerjaan'],
    //     route: "/a-pd/paket-pekerjaan",
    //     icon: <Engineering size="12px" color="info" />,
    //     noCollapse: true,
    // },
    // {
    //     type: "route",
    //     name: "Proyek Strategis",
    //     key: ['/a-pd/proyek-strategis'],
    //     route: "/a-pd/proyek-strategis",
    //     icon: <Star size="12px" color="error" />,
    //     noCollapse: true,
    // },
    // {
    //     type: "route",
    //     name: "Proyek DAK",
    //     key: ['/a-pd/proyek-dak'],
    //     route: "/a-pd/proyek-dak",
    //     icon: <StarHalf size="12px" color="success" />,
    //     noCollapse: true,
    // },
    {
        type: "route",
        name: "Lokasi Pekerjaan",
        key: ['/a-pd/lokasi-pekerjaan'],
        route: "/a-pd/lokasi-pekerjaan",
        icon: <Place size="12px" color="info" />,
        noCollapse: true,
    },
    {
        type: "route",
        name: "Buku Panduan",
        key: ['/a-pd/buku-panduan'],
        route: "/a-pd/buku-panduan",
        icon: <Book size="12px" color="success" />,
        noCollapse: true,
    },
]

export default adminOpdRoutes